import React from "react";
import { iconProps } from "../../Helper";

export const AvatarVideoIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.83337 5.33268C5.83337 4.41185 6.57924 3.66602 7.50004 3.66602C8.42091 3.66602 9.16671 4.41185 9.16671 5.33268C9.16671 6.25355 8.42091 6.99935 7.50004 6.99935C6.57924 6.99935 5.83337 6.25355 5.83337 5.33268ZM7.50004 4.49935C7.95837 4.49935 8.33337 4.87435 8.33337 5.33268C8.33337 5.79102 7.95837 6.16602 7.50004 6.16602C7.04171 6.16602 6.66671 5.79102 6.66671 5.33268C6.66671 4.87435 7.04171 4.49935 7.50004 4.49935Z"
        fill="white"
        className={className}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.50008 7.83203C6.38761 7.83203 4.16675 8.39036 4.16675 9.4987V10.332H10.8334V9.4987C10.8334 8.39036 8.61261 7.83203 7.50008 7.83203ZM7.50008 8.66536C8.62508 8.66536 9.91675 9.2029 10.0001 9.4987H5.00008C5.09591 9.1987 6.37928 8.66536 7.50008 8.66536Z"
        fill="white"
        className={className}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.1667 6.9987C14.1667 10.6806 11.1819 13.6654 7.50004 13.6654C3.81814 13.6654 0.833374 10.6806 0.833374 6.9987C0.833374 3.3168 3.81814 0.332031 7.50004 0.332031C11.1819 0.332031 14.1667 3.3168 14.1667 6.9987ZM12.8334 6.9987C12.8334 9.94423 10.4456 12.332 7.50004 12.332C4.55452 12.332 2.16671 9.94423 2.16671 6.9987C2.16671 4.05318 4.55452 1.66536 7.50004 1.66536C10.4456 1.66536 12.8334 4.05318 12.8334 6.9987Z"
        fill="white"
        className={className}
      />
    </svg>
  );
};
